// extracted by mini-css-extract-plugin
export default {"base":"vp_d3Hpd","icon":"vp_kzERT","title":"vp_I96_B","description":"vp_Kbrhh","arrow":"vp_C_3lJ"};